<template>
    <div class="container">
        <h2 class="header-text">
            Your key suspects
        </h2>
        <div class="cards-container" >
            <div id="char1" :class=" selectedPerson == index ?'card active': 'card'" v-for ="(person,index) in people" :key = "index" v-on:click="selectPerson(index)">
                <div class="front">
                    <img :src = "person.picture" class="person-img" />
                    <p>{{person.name}}</p>
                </div>
                <div class="back">
                    <p>{{person.name}}</p>
                    <p>{{person.description}}</p>
                </div>
            </div>  
        </div>  
        <button class="action-button" v-on:click="handleAccusePerson" :disabled = "selectedPerson == null">
            Accuse
        </button>
        <div class="char-container">
            <div id="back-box">
                <div v-for="input in inputs" :key="input.msg">
                    <SentMsg v-if="input.type==0" v-bind:msg=input.msg >
                    </SentMsg>
                    <GotMsg v-if="input.type==1" v-bind:msg=input.msg >
                    </GotMsg>
                </div>
            </div>
            <form @submit.prevent="onSubmit" class= "form-container">
                    <input type="text" placeholder="Eg: What's farmer jones doing?" id="guess" autocomplete="off" ref="guess"/>
                    <button class="action-button" v-on:click="handleButtonClickNext">
                        Ask
                    </button>
            </form>
        </div>
        <div>
            
        </div>
    </div>
</template>
<script>
// import fetch from 'dns';

import SentMsg from './SentMsg';
import GotMsg from './GotMsg';
import data from "../data/people.json"

const names = ["FARMER_JONES", "MRS_ELLIS", "JOE_THOMPSON", "DR_GREEN"]
// const tasks = [""]

export default {
    name:'Start',
    components: {
        SentMsg, GotMsg
    },
    props:['accusedPerson','setAccusedPerson'],
    data(){
        return{ 
            selectedPerson:null,
            inputs: [],
            people: data.people,
        }
    },    
    methods:{
    selectPerson(person) {
        this.selectedPerson = person
    },
    handleAccusePerson(){
        this.setAccusedPerson(this.selectedPerson);
        this.$router.push('/result');
    },
    onSubmit: function () {
        var msgval = this.$refs.guess.value; 
        // console.log(msgval);
        this.$refs.guess.value = "";
        this.inputs.push({
            msg: msgval,
            type: 0
        });
        //todo post request
        // console.log("day");
        // const article = {"command": "query DR_GREEN glasses"};
        if (msgval == "day" || msgval.split(" ")[0] == "query" || msgval.split(" ")[0] == "accuse"){
            const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ command: msgval })
        };
        fetch("//104.154.83.191:8000/proxy", requestOptions)
        // fetch("http://localhost:5000/proxy", requestOptions)
            .then(async response => {
                var data = await response.json();
                console.log(data);
                data['result'].forEach((item) => {
                    this.inputs.push({
                    msg: item,
                    type: 1
                });    
                });
                
            })
        }
        else{
            fetch("//104.154.83.191:8000/chat/" + msgval)
            // fetch("http://localhost:5000/chat/"+msgval)
            .then(async response => {
                var data = await response.json();
                console.log(data);
                let x = data['name'].toLowerCase()
                if (x == "doctor green" || x == 'green' || x == "dr green" || x == "dr_green" ){
                    data["name"] = "DR_GREEN"
                }
                else if(x == "mrs ellis" || x == "mrs_ellis" || x == "ellis"){
                    data["name"] = "MRS_ELLIS"
                }
                else if(x == "joe thompson" || x == "joe" || x == "thompson" || x == "joe_thompson"){
                    data["name"] = "JOE_THOMPSON"
                }
                else if (x == "farmer jones" || x == "jones" || x == "farmer" || x== "mr jones" || x=="farmer_jones"){
                    data["name"] = "FARMER_JONES"
                }
                /*
                var name = data['name']
                var name = data['name'].toUpperCase()
                name = name.replace(". ", "_");
                name = name.replace(" ", "_");
                name = name.replace(".", "_");
                */
               let name = data['name']
                if (names.includes(name)){
                    var task = data['task'].toLowerCase().substring(4);
                    if(task=="glass"){
                        task="glasses";
                    }
                    console.log(task)
                    let validQueries = ["glasses","doing","height","where"]
                    if (validQueries.includes(task)){
                        var query = "query "+name+" "+task;
                        const requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ command: query })
                        };
                        fetch("http://104.154.83.191:8000/proxy", requestOptions)
                        // fetch("http://localhost:5000/proxy", requestOptions)
                            .then(async response => {
                                var data = await response.json();
                                console.log(data);
                                data['result'].forEach((item) => {
                                    this.inputs.push({
                                    msg: item,
                                    type: 1
                                    });    
                                });
                    
                        })
                    }
                    else {
                        this.inputs.push({
                            msg:"Oops can't cant understand you. Try making it more directional, like what you're doing etc.",
                            type:1
                        })
                    }  
                }
                else{
                    this.inputs.push({
                            msg:"Are you sure the name you're refering to is part of the suspects? That's sus bruh.",
                            type:1
                        })
                }
                console.log(task)

                // data['result'].forEach((item) => {
                //     this.inputs.push({
                //     msg: item,
                //     type: 1
                // });    
                // });
                
            }).catch(() => {
                this.inputs.push({
                            msg:"Oops can't cant understand you. Try making it more directional, like what you're doing etc.",
                            type:1
                        })
            })
        }
    }
  }
}
</script>
<style>
#back-box {
    width:100%;
    padding: 2%;
    display:flex;
    flex-direction: column;
    height: 400px;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    background: rgba(255, 92, 92, 0.35);
}
#back-box::-webkit-scrollbar {
    display: none;
}

.char-container {
    margin-top:4%;
  width:80%;
  display:flex;
  align-items:center;
  justify-content: center;
  padding:1%;
  padding-top:0;
  flex-direction: column;
  border: 8px solid #FF5C5C;
  border-radius:20px
}
.cards-container {
    display:flex;
    flex-direction: row;
    overflow-x: auto;
}
.card {
    display:flex;
    width: 100%;
    flex-direction: column;
    width: 360px;
    height: 360px;
    margin:2%;
    background: white;
    border-radius: 20px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: transform 0.8s;
    align-items: center;
    justify-content: center;
    transform-style: preserve-3d;
    perspective: 1000px;
    border: 4px solid transparent;
    
}   
.card:hover {
  box-shadow: 0 8px 16px 0 #FF5C5C;
  transform: rotateY(180deg);
  cursor: pointer;
}
.person-img {
    height:240px;
    width:240px;
}
.active {
    border-color: #FF5C5C;
}
/* Position the front and back side */
.front, .back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}


/* Style the back side */
.back {
  background-color: white;
  border-radius: 20px;
  transform: rotateY(180deg);
}
#guess {
    width: 100%;
    border: 2px solid #FF5C5C;
    font-size:32px;
    text-align: center;
    font-family: 'Poppins';
    background: #FFFFFF;
    border-radius: 20px;
    margin:2%;
    outline:none;
}
#guess:focus {
    box-shadow: 0px 0px 8px 0px #FF5C5C;
}
.container {
  display:flex;
  justify-content: center;
  flex-direction: column;
}
.image{
    width: 213px;
    height: 196px;
}
.image-container{
    background-color:  rgba(0, 151, 205, 0.54);
    width: 312px;
    height: 251px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2%;
}
.header-text{
  font-size: 36px;
}
.action-button{
  background-color: #0097CD;
  font-size: 32px;
  color: white;
  font-family: 'Poppins';
  width: 312px;
  height: 63px;
  border:none;
  border-radius: 20px;
  outline: none;
  border: none;
  margin:0.5%;  
}
.action-button:hover{
  cursor:pointer;
  opacity: 0.6;
}
.action-button:disabled{
    background-color: #C4C4C4;
}
</style>